import { Box, Button, Typography } from "@mui/material";
import { FC }                      from "react";
import { useRouteError }           from "react-router-dom";
import { isModuleLoadError }       from "src/utils/lazy-with-reload";

// Replaces React Router's default "Unexpected Application Error!" screen. The
// stale-chunk case is recovered automatically by lazyWithReload; this is what
// the user sees when that recovery is exhausted.
export const AppErrorScreen: FC<{ error: unknown }> = ({ error }) => {
  const isStaleBuild = isModuleLoadError(error);

  return (
    <Box sx={{
      display       : "flex",
      flexDirection : "column",
      alignItems    : "center",
      justifyContent: "center",
      gap           : 2,
      height        : "100vh",
      padding       : 3,
      textAlign     : "center",
    }}>
      <Typography variant="h5">
        {isStaleBuild ? "A new version is available" : "Something went wrong"}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {isStaleBuild
          ? "This page was open while the app was updated. Reload to continue."
          : "The page could not be displayed. Reloading usually helps."}
      </Typography>
      <Button variant="contained" onClick={() => window.location.reload()}>
        Reload
      </Button>
    </Box>
  );
};

export const RouteErrorBoundary: FC = () => <AppErrorScreen error={useRouteError()} />;
